/**
 * @generated SignedSource<<7d780d7582bd518f753bf6e49df16ae1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
export type SendJobOpportunityInput = {
  clientMutationId?: string | null | undefined;
  freelancerRawIdOrSlug?: string | null | undefined;
  jobId?: string | null | undefined;
  userId?: string | null | undefined;
};
export type NotifyAboutJob_Mutation$variables = {
  input: SendJobOpportunityInput;
};
export type NotifyAboutJob_Mutation$data = {
  readonly sendJobOpportunity: {
    readonly jobApplication: {
      readonly status: JobApplicationStatus;
    } | null | undefined;
    readonly user: {
      readonly canNotify: boolean | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type NotifyAboutJob_Mutation = {
  response: NotifyAboutJob_Mutation$data;
  variables: NotifyAboutJob_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canNotify",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotifyAboutJob_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendJobOpportunityPayload",
        "kind": "LinkedField",
        "name": "sendJobOpportunity",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "JobApplication",
            "kind": "LinkedField",
            "name": "jobApplication",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotifyAboutJob_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendJobOpportunityPayload",
        "kind": "LinkedField",
        "name": "sendJobOpportunity",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "JobApplication",
            "kind": "LinkedField",
            "name": "jobApplication",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73b0085ffac38a03785c3f046a8f725e",
    "id": null,
    "metadata": {},
    "name": "NotifyAboutJob_Mutation",
    "operationKind": "mutation",
    "text": "mutation NotifyAboutJob_Mutation(\n  $input: SendJobOpportunityInput!\n) {\n  sendJobOpportunity(input: $input) {\n    user {\n      id\n      canNotify\n    }\n    jobApplication {\n      status\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "880aa5857300ab22a630f6ed7f37a032";

export default node;
